import { render, staticRenderFns } from "./SelectionField.vue?vue&type=template&id=28d690ba&scoped=true&"
import script from "./SelectionField.vue?vue&type=script&lang=ts&"
export * from "./SelectionField.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionField.vue?vue&type=style&index=0&id=28d690ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d690ba",
  null
  
)

export default component.exports